export default "__VITE_ASSET__BtyGix47__"